"use client";

import React, { useRef } from "react";
import { useGoogleAd } from "./execute-add-ad";
import AdWrapper from "./AdWrapper";

declare global {
  interface Window {
    adsbygoogle?: any | any[];
  }
}

function DisplayAdItem() {
  const adsRef = useRef<HTMLModElement | null>(null);

  useGoogleAd(adsRef);

  return (
    <ins
      ref={adsRef}
      className="adsbygoogle"
      style={{
        display: "block",
        border:
          process.env.NODE_ENV === "development" ? "1px solid red" : "none",
        backgroundColor:
          process.env.NODE_ENV === "development"
            ? "rgba(255, 0, 0, 0.1)"
            : "none",
      }}
      data-ad-client="ca-pub-9143210451390429"
      data-ad-slot="7500142108"
      data-ad-format="auto"
      data-full-width-responsive="true"
    ></ins>
  );
}

export default function DisplayAd() {
  return (
    <AdWrapper>
      <DisplayAdItem />
    </AdWrapper>
  );
}
